enum PaymentType {
    Conventional,
    Doku,
    Midtrans,
    Paypal,
    MidtransDirectDebit
}

export default PaymentType;